import api from './api';

const assetVendorMasterService = {
  // Get all asset vendors
  getAllVendors: async (params = {}) => {
    try {
      const response = await api.get('/asset-vendor-master', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching asset vendors:', error);
      throw error;
    }
  },

  // Get asset vendor by ID
  getVendorById: async (id) => {
    try {
      const response = await api.get(`/asset-vendor-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching asset vendor:', error);
      throw error;
    }
  },

  // Create asset vendor
  createVendor: async (data) => {
    try {
      const response = await api.post('/asset-vendor-master', data);
      return response.data;
    } catch (error) {
      console.error('Error creating asset vendor:', error);
      throw error;
    }
  },

  // Update asset vendor
  updateVendor: async (id, data) => {
    try {
      const response = await api.put(`/asset-vendor-master/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating asset vendor:', error);
      throw error;
    }
  },

  // Delete asset vendor
  deleteVendor: async (id) => {
    try {
      const response = await api.delete(`/asset-vendor-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting asset vendor:', error);
      throw error;
    }
  },

  // Get asset vendor statistics
  getVendorStats: async () => {
    try {
      const response = await api.get('/asset-vendor-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching asset vendor statistics:', error);
      throw error;
    }
  },

  // Get next vendor code
  getNextVendorCode: async () => {
    try {
      const response = await api.get('/asset-vendor-master/next-code');
      return response.data;
    } catch (error) {
      console.error('Error fetching next vendor code:', error);
      throw error;
    }
  }
};

export default assetVendorMasterService;
